import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';

import { Fetch, Header } from '@commonComponents';
import { Container } from '@styledComponents';
import { getTenantProfile } from '@api/tenants';

import ProfileCommon from './TenantProfileCommon';

export default function ProfilePrivate() {
    const navigate = useNavigate();
    const fetch = React.useCallback(() => getTenantProfile(), []);
    return (
        <Container>
            <Header
                title="Företagsprofil"
                CustomComponent={(
                    <Button
                        variant="contained"
                        startIcon={<EditIcon />}
                        onClick={() => navigate('/company-profile/edit')}
                    >
                        Redigera
                    </Button>
                )}
            />
            <Fetch
                fetch={fetch}
                Component={ProfileCommon}
            />
        </Container>
    );
}
